import {WorkspaceSwitcher as Shared} from '../../../packages/auth-client/src/WorkspaceSwitcher'
import '../../../packages/auth-client/src/workspace-switcher.css'
import {useAuth} from './hooks/useAuth'
export default function WorkspaceSwitcher({beforeSwitch}:{beforeSwitch?:()=>Promise<boolean>}){const{profile}=useAuth();return <Shared tenant={profile?.tenant_id} beforeSwitch={beforeSwitch}/>}
